import React from 'react'

import lock from 'assets/lock.svg'
import mail from 'assets/mail.svg'
import Button from 'features/common/components/Button'
import FormField from './common/components/FormField'
import FormInput from './common/components/FormInput'
import {useTranslation} from 'react-i18next'
import useSignin from 'features/unauthorized/components/AuthPage/common/hooks/useSignin'
import PasswordFormInput from './common/components/PasswordFormInput'
import {useTypedTranslation} from 'i18n'

const forgotPasswordLink =
    'https://nocoins.atlassian.net/servicedesk/customer/portals'

export function Signin() {
    const {t} = useTranslation()
    const {t: typedT} = useTypedTranslation()

    const {data, errors, onChange, onSubmit, onSubmitError, loading} =
        useSignin()
    const onChangeInput =
        (prop: keyof typeof data) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange({prop, value: e.target.value.toString()})
        }

    const noErrors = Object.keys(errors).length === 0
    const noEmptyFields = !!(data.email && data.password)

    const disableSubmit = !(noErrors && noEmptyFields)

    return (
        <form
            className="flex w-[36.5rem] flex-col items-stretch justify-center"
            onSubmit={(e) => e.preventDefault()}
        >
            <div className="mb-10 w-full text-left text-[40px]">
                {t('AUTH_SIGNIN_TITLE')}
            </div>

            <div className="flex min-w-0 flex-1 flex-col items-stretch justify-center gap-7.5">
                <FormField title={t('AUTH_EMAIL')}>
                    <FormInput
                        icon={mail}
                        iconAlt="E-mail"
                        error={errors.email}
                        inputProps={{
                            value: data.email,
                            onChange: onChangeInput('email'),
                            name: 'email',
                            placeholder: t('AUTH_EMAIL_PLACEHOLDER'),
                            type: 'email',
                            autoComplete: 'email',
                        }}
                    />
                </FormField>
                <FormField title={t('AUTH_PASSWORD')}>
                    <PasswordFormInput
                        icon={lock}
                        iconAlt="Password"
                        error={errors.password}
                        inputProps={{
                            value: data.password,
                            onChange: onChangeInput('password'),
                            name: 'password',
                            placeholder: t('AUTH_SIGNIN_PASSWORD_PLACEHOLDER'),
                            type: 'password',
                            autoComplete: 'current-password',
                        }}
                    />
                </FormField>
                {onSubmitError && (
                    <div className="pl-4 text-xs text-red-700">
                        {typedT(onSubmitError.message)}
                    </div>
                )}
                <div className="flex w-full justify-between">
                    <a
                        className="border-none bg-white text-xl text-yellow-40"
                        target="_blank"
                        rel="noreferrer"
                        href={forgotPasswordLink}
                    >
                        {t('AUTH_FORGOT_PASSWORD')}
                    </a>
                    <div>
                        <Button
                            type="submit"
                            className="rounded-full py-4 px-16"
                            disabled={disableSubmit}
                            onClick={onSubmit}
                            isLoading={loading}
                        >
                            {t('AUTH_SIGNIN_BUTTON')}
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default Signin
